import React from 'react';

interface HeartIconProps {
  filled?: boolean;
  className?: string;
}

const HeartIcon: React.FC<HeartIconProps> = ({ filled = false, className = '' }) => {
  return (
    <svg
      className={`w-4 h-4 ${className}`}
      fill={filled ? '#253658' : 'none'}
      stroke={filled ? '#253658' : '#253658'}
      strokeWidth={2}
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
      />
    </svg>
  );
};

export default HeartIcon;
